import { resources } from "@constants/hardcoded-strings";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";
import { archiveRelyingPartyRequest } from "@requests/axnadmin-core/archive-relying-party";
import { AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { GenericAccountStateTypes } from "@enums/generic-account-state-types";
import { updateRelyingParties } from "@redux/actions/relying-parties-actions";

export const archiveRelyingPartyReduxRequest = (dispatch: Dispatch) => async (
    relyingPartyId: string
): Promise<AxnRelyingParty> => {
    const { data, error } = await archiveRelyingPartyRequest(relyingPartyId);
    if (data) {
        displaySuccessModal(
            dispatch,
            resources.requests.archiveRelyingParty.success.title,
            resources.requests.archiveRelyingParty.success.message
        );
        dispatch(updateRelyingParties(data.transferObject, GenericAccountStateTypes.ARCHIVE));
        return data.transferObject;
    } else {
        if (error) {
            const errorResource = resources.requests.archiveRelyingParty.error;

            logAndDisplayErrorModal(
                dispatch,
                error,
                errorResource.title,
                errorResource.message
            );
        }
    }

    return null;
};